import { closeModal } from "../../../ui/containers/Modal";
import { floodFill } from "../../../ui/helpers";
import { TextButton } from "../../../ui/input/TextButton";
import { ComponentF, createElement } from "../../../ui/ui";
import Colors from "../../Colors";
import { HelpComponent } from "./helpComponent";

export const HelpModal: ComponentF<void> = (C) => {
  floodFill(C.display, C.bounds, Colors.OFF_BLACK);

  return [
    createElement(
      HelpComponent,
      { x: 0, y: 0, w: C.bounds.w, h: C.bounds.h },
      { live: true }
    ),
    createElement(
      TextButton,
      { x: 0, y: C.bounds.h - 1, w: 10, h: 1 },
      {
        title: "Close",
        keyLabel: "Esc",
        keys: ["Escape", "?", "/"],
        onClick: () => {
          closeModal();
        },
      }
    ),
  ];
};
